module.exports = __webpack_public_path__ + "static/media/rules_6.dd43fa27.png";